<template>
    <div class="edc-modal">
        <SOSlotModal :modal-title="getTitleModal" :modal-id="modalId" @close="back">
            <template v-slot:modal-body>
                <div>
                    <MessageWrapper :text-message="getMessage" :preview-mode="isDrafted" :category="category">
                        <template v-slot:msg_head>
                            <div class="d-flex-between-center" style="align-items: unset;">
                                <SOInputOnOff :checkboxes="getCheckbox" @selected="toogleOnOff" :checked="isDrafted" />
                                <div class="bg-white" v-if="isEdit">
                                    <SOButton
                                        :outline="true"
                                        :text="'Ubah template'"
                                        :id="'confirm-register'"
                                        @action="gotoEdit"
                                    />
                                </div>
                            </div>
                        </template>
                    </MessageWrapper>
                </div>
            </template>
        </SOSlotModal>
    </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import resulter from "@/store/utils/resulter";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal.vue";
import SOButton from "@/so-components/global/ui/SOButton";
import SOInputOnOff from "@/so-components/global/input/SOInputOnOff.vue";
import MessageWrapper from "../MessageWrapper.vue";

import settingWhatsapp from "../../static/settingWhatsapp";
import { moduleName } from "../../store/state";

const previewMode = {
    id: "preview-mode",
    data: {
        name: "preview-mode",
        data: [
            {
                id: "preview-mode",
                value: "1",
                title: `<label class='f-regular f-14 f-c-black m-0' for='preview-mode'>Preview data</label>`,
                checked: false,
                titleBold: false,
            },
        ],
    },
};

export default {
    name: "PreviewTextMessage",
    components: {
        SOSlotModal,
        SOButton,
        SOInputOnOff,
        MessageWrapper,
    },
    data() {
        return {
            title: "Nota transaksi reguler & deposit",
            backLink: "wa_autosender.detail_perangkat.daftar_oulet.set_draft",
            modalId: "preview-msg",
            isDrafted: false,
            isEdit: false,
            category: "",
        };
    },
    beforeRouteEnter(to, from, next) {
        next((vm) => {
            if (from.name === "wa_autosender.detail_perangkat.daftar_oulet.set_draft") {
                vm.setEditMode(true);
            }
        });
    },
    beforeRouteLeave(to, from, next) {
        this.closeModal();
        next();
    },
    mounted() {
        $(`#${this.modalId}`).modal("show");
    },
    computed: {
        ...mapGetters(moduleName, {
            settingOutlet: "settingOutlet",
            // dataDeviceTiny: "dataDeviceTiny",
            // isFetching: "isFetching",
            // response: "response",
        }),
        getCheckbox() {
            return previewMode.data;
        },
        getSetting() {
            return this.settingOutlet.setting;
        },
        getTemplate() {
            return this.settingOutlet.template;
        },
        getJenisSetting() {
            return this.$route.query.jenisSetting;
        },
        getTitleModal() {
            if (this.$route.query.jenisSetting) {
                let set = settingWhatsapp.find((s) => s.id === this.getJenisSetting);

                return set.data.data[0].label;
            } else {
                return this.title;
            }
        },
        getMessage() {
            switch (this.getJenisSetting) {
                case "transaksi-snap":
                    this.category = "transaksi";
                    return this.getTemplate.snap_transaksi_nota;
                case "top-up-deposit":
                    this.category = "beli_deposit";
                    return this.getTemplate.beli_deposit;
                case "top-up-epayment":
                    this.category = "beli_emoney";
                    return this.getTemplate.beli_emoney;
                case "notif-selesai":
                    this.category = "selesai";
                    return this.getTemplate.selesai;
                case "bukti-ambil":
                    this.category = "transaksi";
                    return this.getTemplate.bukti_ambil;
                case "notif-pengambilan":
                    this.category = "ambil";
                    return this.getTemplate.ambil;
				case "pelunasan":
					this.category = "pelunasan";
					return this.getTemplate.pelunasan;
                case "transaksi-reg":
                default:
                    this.category = "transaksi";
                    return this.getTemplate.transaksi;
            }
        },
    },
    methods: {
        ...mapActions({
            // setFetching: `${moduleName}/setFetching`,
        }),
        async back() {
            await this.$router.push({ name: this.backLink });
        },
        closeModal() {
            $(`#${this.modalId}`).modal("hide");
        },
        toogleOnOff(val) {
            this.isDrafted = val;
        },
        gotoEdit() {
            this.$router.push({
                name: "wa_autosender.detail_perangkat.daftar_oulet.edit_template",
                query: { title: this.title, jenisSetting: this.$route.query.jenisSetting },
            });
        },
        setEditMode(val) {
            this.isEdit = val;
        },
    },
};
</script>
